import { ReactComponent as AITutoIcon } from "assets/img/icons/AI-tutor.svg";
import { ReactComponent as NameIdeaIcon } from "assets/img/icons/name-idea.svg";
import { useState } from "react";
import GeneratedNamesResponse from "./GeneratedNamesResponse";
import GeneratedNotesResponse from "./GeneratedNotesResponse";

const InnovativeTools = ({ query, setError, aiOption, setAiOption }) => {
  const options = [
    {
      id: 1,
      name: "AI Tutor",
      Icon: <AITutoIcon className="ai-avatar-icon tutor-Icon" />,
      submittingText: "Generating notes...",
    },
    {
      id: 2,
      name: "Name your Idea",
      Icon: <NameIdeaIcon className="ai-avatar-icon" />,
      submittingText: "Generating Names...",
    },
  ];
  const [submittingId, setSubmittingId] = useState(0);
  const [aiTutor, setAITutor] = useState(false);
  const [nameIdea, setNameIdea] = useState(false);

  const checkQueryLength = () => {
    if (query.length < 50 || query.length > 5000) {
      setError(
        "To use Innovative tools, text should be 50 to 5000 characters."
      );
      return false;
    }

    setError("");
    return true;
  };

  const generateNames = async () => {
    setNameIdea(true);
    setSubmittingId(0);
  };

  const generateNotes = () => {
    setAITutor(true);
    setSubmittingId(0);
  };

  const handleOption = async (id) => {
    if (aiOption) setAiOption(0);
    if (!checkQueryLength()) return false;
    setSubmittingId(id); // setting id of the option which is going to submit
    if (id === 2) return generateNames();
    if (id === 1) return generateNotes();
  };

  return (
    <>
      {options.map((o) => (
        <div
          className="ai-options"
          role="button"
          onClick={() => handleOption(o.id)}
        >
          {o.Icon}
          <div className="ai-option-name">
            {submittingId === o.id ? o.submittingText : o.name}
          </div>
        </div>
      ))}

      {nameIdea && (
        <GeneratedNamesResponse
          handleModal={() => setNameIdea(false)}
          query={query}
        />
      )}

      {aiTutor && (
        <GeneratedNotesResponse
          handleModal={() => setAITutor(false)}
          defaultQuery={query}
        />
      )}
    </>
  );
};

export default InnovativeTools;
